exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slider-gallery-main,.slider-gallery-nav{transition:opacity .4s ease-in-out}.slider-gallery-main .carousel-cell{opacity:0!important;z-index:0}.slider-gallery-main .carousel-cell.is-selected{opacity:1!important;z-index:100}.hidden,.hidden-sub{opacity:0;max-height:456px;overflow-y:hidden}", ""]);

// exports
